import { Toast as BaseToast } from '@base-ui/react/toast';

/**
 * The Frost toast stack, reachable without a provider in scope.
 *
 * `useToastManager()` throws outside `<Toast.Provider>`, and the moves this stack reports are
 * raised from a mutation callback — `useMoveChat` is exercised by `renderHook`, so the hook form
 * would force a provider into shared test infrastructure for every suite that transitively reaches
 * it. A module singleton is global mutable state, which is the price: keep it write-only from the
 * app's side, one `add()` per completed move, so swapping it for the hook stays a one-file change.
 */
export const frostToastManager = BaseToast.createToastManager();
